import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./home-entertainment.${locale}.json`));
